import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({ store_name: "", slug: "", owner_name: "", email: "", password: "", phone: "", city: "", country: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const slug = (f.slug || f.store_name).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
      await api.post("/public/register", { ...f, slug });
      const res = await login(f.email, f.password);
      toast.success("Boutique créée avec succès !");
      if (res.ok && res.user.store_slug) navigate(`/store/${res.user.store_slug}/admin`);
      else navigate("/login");
    } catch (e2) { toast.error(apiError(e2)); }
    setLoading(false);
  };

  return (
    <div className="vp-dark min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-lg">
        <Link to="/" className="block text-center mb-6">
          <span className="font-display text-4xl font-bold text-white">Vision<span className="vp-accent-text">POS</span></span>
        </Link>
        <div className="vp-card rounded-2xl p-8">
          <h1 className="font-display text-3xl font-bold text-white mb-1">Créer votre boutique</h1>
          <p className="text-sm text-slate-400 mb-6">14 jours d'essai gratuit, sans carte bancaire</p>
          <form onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="sm:col-span-2">
              <Label className="text-slate-300 text-sm mb-1.5 block">Nom de la boutique</Label>
              <Input value={f.store_name} onChange={set("store_name")} required data-testid="reg-store-name" className="bg-black/30 border-white/10 text-white" placeholder="Ma Boutique Mode" />
            </div>
            <div className="sm:col-span-2">
              <Label className="text-slate-300 text-sm mb-1.5 block">Sous-domaine</Label>
              <div className="flex items-center">
                <Input value={f.slug} onChange={set("slug")} data-testid="reg-slug" className="bg-black/30 border-white/10 text-white rounded-r-none" placeholder="ma-boutique" />
                <span className="px-3 py-2 text-sm text-slate-400 bg-black/40 border border-l-0 border-white/10 rounded-r-md">.vilopos.com</span>
              </div>
            </div>
            <div><Label className="text-slate-300 text-sm mb-1.5 block">Propriétaire</Label>
              <Input value={f.owner_name} onChange={set("owner_name")} required data-testid="reg-owner" className="bg-black/30 border-white/10 text-white" /></div>
            <div><Label className="text-slate-300 text-sm mb-1.5 block">Téléphone</Label>
              <Input value={f.phone} onChange={set("phone")} className="bg-black/30 border-white/10 text-white" /></div>
            <div><Label className="text-slate-300 text-sm mb-1.5 block">Ville</Label>
              <Input value={f.city} onChange={set("city")} className="bg-black/30 border-white/10 text-white" /></div>
            <div><Label className="text-slate-300 text-sm mb-1.5 block">Pays</Label>
              <Input value={f.country} onChange={set("country")} className="bg-black/30 border-white/10 text-white" /></div>
            <div><Label className="text-slate-300 text-sm mb-1.5 block">Email</Label>
              <Input value={f.email} onChange={set("email")} type="email" required data-testid="reg-email" className="bg-black/30 border-white/10 text-white" /></div>
            <div><Label className="text-slate-300 text-sm mb-1.5 block">Mot de passe</Label>
              <Input value={f.password} onChange={set("password")} type="password" required data-testid="reg-password" className="bg-black/30 border-white/10 text-white" /></div>
            <Button type="submit" disabled={loading} data-testid="reg-submit" className="sm:col-span-2 vp-accent-bg text-black font-semibold hover:opacity-90">
              {loading && <Loader2 className="animate-spin mr-2" size={16} />} Créer ma boutique
            </Button>
          </form>
          <p className="text-center text-sm text-slate-400 mt-6">Déjà un compte ? <Link to="/login" className="vp-accent-text hover:underline">Se connecter</Link></p>
        </div>
      </div>
    </div>
  );
}
